import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('pl');

  // One-time migration to make PL the default for everyone (including return visitors)
  useEffect(() => {
    try {
      const hasMigrated = localStorage.getItem('lang_migrated_pl');
      const savedLanguage = localStorage.getItem('language');

      if (!hasMigrated) {
        // Force default to PL on first load after this change
        localStorage.setItem('language', 'pl');
        localStorage.setItem('lang_migrated_pl', '1');
        setLanguage('pl');
      } else if (savedLanguage) {
        setLanguage(savedLanguage);
      } else {
        // No saved language, default to PL
        setLanguage('pl');
      }
    } catch (_) {
      // In case localStorage is unavailable, default to PL
      setLanguage('pl');
    }
  }, []);

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};